export default function onPaste(pasteEvent) {
    if (pasteEvent.clipboardData == false) return;
    const items = pasteEvent.clipboardData.items;
    if (items == undefined) return;
    for (var i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") >= 0) this.onImageBlob(items[i].getAsFile());
        if (items[i].type.indexOf("text") >= 0) items[i].getAsString(this.onText);
    }
}
